import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	customerVideos: [],
};

const customerSettingsSlice = createSlice({
	name: 'customerVideos',
	initialState: initialState,
	reducers: {
		setCustomerVideos: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setCustomerVideos, reset } = customerSettingsSlice.actions;

export default customerSettingsSlice.reducer;